import UserManagement from '@src/pages/UserManagement';

export function UserManagementContainer() {
    return <UserManagement />;
}
